import React, { useEffect, useState } from "react";
import { IoMdStar } from "react-icons/io";

import { fetchContactStats } from "../Hooks/useContactStats";
import CounterSkeleton from "./CounterSkeleton";

const DigitalReach = () => {

  const [totalAttempt, setTotalAttempts] = useState(0);
  const [totalConversion, setTotalConversion] = useState(0);
  const [totalRating, setTotalRating] = useState(0);
  const [contactedVoters, setContactedVoters] = useState(0);
  const [dailyCount, setDailyCount] = useState({
    totalAttempt: 0,
    tracking_contacted_voters_percent: 0,
    tracking_conversion_percent: 0,
    tracking_rating: 0,
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchDashboardCount = async () => {
    const token = localStorage.getItem("token");
    setIsLoading(true);
    try {
      await fetchContactStats({
        token,
        setTotalAttempts,
        setTotalConversion,
        setTotalRating,
        setContactedVoters,
        setDailyCount,
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (navigator.onLine) {
      setTimeout(() => {
        fetchDashboardCount();
      }, 2000);
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <div className="bg-canvas-userbar w-full md:px-12 px-4 py-8 flex flex-col gap-8">
      <div className="bg-canvas-white md:p-8 p-3 flex flex-col gap-8 md:gap-3 rounded">
        <h1>Lifetime Dashboard</h1>
        <div className="flex flex-col md:flex-row md:items-center gap-6 lg:gap-16">
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">Attempts</h3>
            {isLoading ? <CounterSkeleton /> : <h3 className="font-normal">{totalAttempt}</h3>}
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">
              Contacted Rate
            </h3>
            {isLoading ? <CounterSkeleton /> : <h3 className="font-normal">{contactedVoters} %</h3>}
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">
              Conversion Rate
            </h3>
            {isLoading ? <CounterSkeleton /> : <h3 className="font-normal">{totalConversion} %</h3>}
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">Rating</h3>
            {isLoading ? (
              <CounterSkeleton />
            ) : (
              <h3 className="font-normal flex gap-1 items-center">
                {totalRating} <IoMdStar />
              </h3>
            )}
          </div>
        </div>
      </div>

      <div className="bg-canvas-white md:p-8 p-3 flex flex-col gap-8 md:gap-3 rounded">
        <h1>Daily Dashboard</h1>
        <div className="flex flex-col md:flex-row md:items-center gap-6 lg:gap-16">
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">Attempts</h3>
            {isLoading ? <CounterSkeleton /> : <h3 className="font-normal">{dailyCount?.totalAttempt}</h3>}
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">
              Contacted Rate
            </h3>
            {isLoading ? (
              <CounterSkeleton />
            ) : (
              <h3 className="font-normal">
                {dailyCount?.tracking_contacted_voters_percent} %
              </h3>
            )}
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">
              Conversion Rate
            </h3>
            {isLoading ? (
              <CounterSkeleton />
            ) : (
              <h3 className="font-normal">
                {dailyCount?.tracking_conversion_percent} %
              </h3>
            )}
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-canvas-secondery font-semibold">Rating</h3>
            {isLoading ? (
              <CounterSkeleton />
            ) : (
              <h3 className="font-normal flex gap-1 items-center">
                {dailyCount?.tracking_rating} <IoMdStar />
              </h3>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalReach;
